var _path, _path2, _path3, _path4, _rect, _rect2, _rect3, _rect4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.6174 15.5289C39.8659 16.6331 38.9799 17.6237 37.8481 17.6237C36.906 17.6237 36.1189 16.9267 35.8921 16.0123C34.3946 9.97656 29.5377 5.27226 23.4301 4.01707C22.4762 3.82103 21.7324 3.01844 21.7324 2.0446C21.7324 0.942206 22.6754 0.0656024 23.7597 0.264048C31.6175 1.70205 37.8692 7.75931 39.6174 15.5289Z",
    fill: "#666666"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.428497 15.5289C0.180042 16.6331 1.06597 17.6237 2.19781 17.6237C3.13991 17.6237 3.92695 16.9267 4.15381 16.0123C5.65126 9.97656 10.5082 5.27226 16.6158 4.01707C17.5697 3.82103 18.3135 3.01844 18.3135 2.0446C18.3135 0.942206 17.3705 0.0656024 16.2862 0.264048C8.42838 1.70205 2.17667 7.75931 0.428497 15.5289Z",
    fill: "#666666"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.9981 20.7355C39.083 20.7355 39.9513 21.654 39.7767 22.7247C38.4186 31.052 31.939 37.6516 23.6919 39.1624C22.608 39.361 21.6653 38.4849 21.6653 37.3829C21.6653 36.4099 22.4085 35.6078 23.3616 35.4119C29.7886 34.0906 34.8288 28.9532 36.0301 22.4636C36.209 21.4967 37.0148 20.7355 37.9981 20.7355Z",
    fill: "#666666"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.00197 20.7114C0.917044 20.7114 0.0487728 21.6299 0.223404 22.7007C1.58147 31.028 8.06104 37.6275 16.3082 39.1384C17.3921 39.3369 18.3347 38.4608 18.3347 37.3589C18.3347 36.3858 17.5916 35.5838 16.6384 35.3878C10.2115 34.0665 5.17128 28.9291 3.97 22.4396C3.79101 21.4727 2.9853 20.7114 2.00197 20.7114Z",
    fill: "#666666"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 10.4183,
    y: 9.61609,
    width: 8.24081,
    height: 8.38666,
    rx: 4.1204,
    fill: "#666666"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 10.4183,
    y: 20.6488,
    width: 8.24081,
    height: 8.38666,
    rx: 1,
    fill: "#666666"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 21.451,
    y: 20.6488,
    width: 8.24081,
    height: 8.38666,
    rx: 4.1204,
    fill: "#666666"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 21.451,
    y: 9.61609,
    width: 8.24081,
    height: 8.38666,
    rx: 1,
    fill: "#666666"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.9babb321.svg";
export { ForwardRef as ReactComponent };